import React from "react";
import { Hero } from "./Hero";

import { hc, InferResponseType } from "hono/client";
import { SitesRoute } from "../api/sites";
import { About } from "./About";
import { ContactForm } from "./ContactForm";
import { Features } from "./Features";
import { Faq } from "./Faq";
import Gallery from "./Photos";
import { TextSection } from "./TextSection";

const _client = hc<SitesRoute>("/");

export interface RenderSiteProps {
  site: (InferResponseType<(typeof _client.api)["sites"][":siteId"]["$get"]> & {
    success: true;
  })["data"]["site"] & { textColor: string };
}

export const RenderSite: React.FC<RenderSiteProps> = (_props) => {
  const props = {
    ..._props,
    site: {
      ..._props.site,
      textColor: `${_props.site.color}-${
        _props.site.color_weight > 300 ? "50" : "950"
      }`,
    },
  } as RenderSiteProps;

  return (
    <div>
      <Hero {...props} />
      {props.site.services?.is_enabled && <Features {...props} />}
      {props.site.photos?.is_enabled && <Gallery {...props} />}
      {props.site.teams?.is_enabled && <About {...props} />}
      <TextSection {...props} />
      {props.site.faq?.is_enabled && <Faq {...props} />}
      {props.site.contactForm?.is_enabled && <ContactForm {...props} />}
    </div>
  );
};
